import { moneyFormat } from "./money-format";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Account } from "types/account";
import { Charity } from "types/charity";
import {
  Acknowledgement,
  GRANT_PURPOSE_ENUM,
  GrantPurpose,
} from "types/grant-request";
import { User } from "types/user";
import { getOrdinalSuffix } from "./getOrdinalSuffix";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
// pdfMake.fonts = {
//   TimesNewRoman: {
//     normal: "./fonts/times-new-roman.ttf",
//     bold: "./fonts/times-new-roman-bold.ttf",
//     italics: "./fonts/times-new-roman-italic.ttf",
//     bolditalics: "./fonts/times-new-roman-bold-italic.ttf",
//   },
// };

export interface AcknowledgementLetter {
  acknowledgement: Acknowledgement;
  amount: number;
  fund: Account;
  user: User;
  charity: Charity;
  purpose: GrantPurpose;
  personToInform: string;
}
export const generateAcknowledgementLetterHtml = ({
  acknowledgement,
  amount,
  fund,
  user,
  charity,
  purpose,
  personToInform,
}: AcknowledgementLetter) => {
  const svgBase64 =
    "data:image/jpeg;base64,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";
  return [
    {
      image: svgBase64,
      width: 170,
      margin: [0, 0, 0, 20],
    },
    {
      text: `${new Date().toLocaleDateString("en-us", {
        month: "long",
      })} ${getOrdinalSuffix(
        new Date().getUTCDate() as number
      )}, ${new Date().toLocaleDateString("en-us", {
        year: "numeric",
      })}`,
      fontSize: 10,
      margin: [20, 0, 0, 20],
    },
    {
      text: charity.name,
      fontSize: 10,
      margin: [20, 0, 20, 0],
    },
    {
      text: `${charity.street && charity.street} ${
        charity.street2 ? charity.street2 : ""
      }\n${charity.city && charity.city}, ${charity.state && charity.state} ${
        charity.zip && charity.zip
      }, ${charity.country && charity.country}`,
      fontSize: 10,
      margin: [20, 0, 0, 20],
    },
    {
      text: `Dear friends at ${charity.name},`,
      fontSize: 10,
      margin: [20, 0, 0, 0],
    },
    personToInform
      ? {
          text: `cc: ${personToInform}`,
          fontSize: 10,
          margin: [20, 0, 0, 0],
        }
      : {},
    {
      text: `We are pleased to send you a grant from Neta Foundation, Inc., a 501(c)(3) nonprofit organization that sponsors donor advised funds.`,
      fontSize: 10,
      margin: [20, 20, 20, 20],
    },
    !acknowledgement.anonymous &&
    (acknowledgement.showFundNameInRecommendation ||
      (acknowledgement.donorSelections &&
        acknowledgement.donorSelections.some(
          (selection) => selection.recommendation
        )))
      ? {
          text: `This grant is made at the recommendation of:\n${
            acknowledgement.showFundNameInRecommendation
              ? `${fund.fundAccountName}\n`
              : ""
          }${
            acknowledgement.donorSelections &&
            acknowledgement.donorSelections.length > 0
              ? acknowledgement.donorSelections
                  .filter((selection) => {
                    return selection.recommendation;
                  })
                  .map((selection) => {
                    return `${selection.memberName}\n`;
                  })
                  .join("")
              : ""
          }`,
          fontSize: 10,
          margin: [20, 0, 0, 10],
        }
      : {},
    {
      text: `Grant Amount: $${moneyFormat(+amount)}`,
      fontSize: 10,
      margin: [20, 0, 0, 10],
    },
    {
      text: `Purpose of Grant: ${
        purpose.type === GRANT_PURPOSE_ENUM.SPECIFIC
          ? purpose.note
          : "Unrestricted"
      }`,
      fontSize: 10,
      margin: [20, 0, 0, 20],
    },
    {
      text: `${
        !acknowledgement.anonymous ||
        acknowledgement.inMemoryOf ||
        acknowledgement.inHonorOf
          ? "For this grant, please recognize:\n"
          : ""
      }${
        acknowledgement.showFundNameInRecognition && !acknowledgement.anonymous
          ? `${fund.fundAccountName}\n`
          : ""
      }${
        acknowledgement.donorSelections &&
        acknowledgement.donorSelections.length > 0
          ? acknowledgement.donorSelections
              .filter((selection) => {
                return (
                  selection.recognition || selection.recognitionWithAddress
                );
              })
              .map((selection) => {
                return `${selection.memberName}\n${
                  selection.recognitionWithAddress
                    ? `${selection.address}\n`
                    : ""
                }`;
              })
              .join("")
          : ""
      }${
        acknowledgement.inMemoryOf
          ? `In memory of ${acknowledgement.inMemoryOf}\n`
          : ""
      }${
        acknowledgement.inHonorOf
          ? ` In honor of ${acknowledgement.inHonorOf}\n`
          : ""
      }`,
      fontSize: 10,
      margin: [20, 0, 20, 20],
    },
    !acknowledgement.anonymous
      ? {
          text: `${
            acknowledgement.visibility
              ? "Your organization may thank/recognize the individuals/fund that recommended this grant, but you may not send them any tax acknowledgement or receipt. Please do not share information about our donors with third parties."
              : "Your organization may thank the individuals/fund that recommended this grant, but you may not send them any tax acknowledgement or receipt. Please do not share information about our donors with third parties.\n\nAt the request of the recommending donor, do not publish any identifying or contact information contained in this grant letter in your newsletters, web pages, reports, or other materials."
          }`,
          fontSize: 10,
          margin: [20, 0, 20, 20],
        }
      : "",
    {
      text: "By accepting this grant, your organization agrees (a) to use the grant exclusively in furtherance of your organization’s tax-exempt purpose, (b) that this grant may not result in benefits, goods, or services to the donor, the fund advisor, members of their families, and businesses they control (prohibited benefits include, but are not limited to, paying a portion or in full for dinners, events, and memberships that have an associated nondeductible portion; tuition; and goods at a charitable auction), and (c) that this grant cannot be used for lobbying purposes or to support political campaigns. If you are unable to comply with these grant conditions, you must contact us immediately and return the funds to Neta.",
      fontSize: 10,
      margin: [20, 0, 20, 20],
    },
    {
      text: "Sincerely,",
      fontSize: 10,
      margin: [20, 0, 20, 20],
    },
    {
      text: "Neta Foundation, Inc.",
      fontSize: 10,
      margin: [20, 0, 20, 70],
    },
  ];
};

const buildDocDefinition = (template: any) => ({
  content: [template],
  footer: function () {
    return {
      table: {
        widths: ["*", "*", "*"],
        body: [
          [
            {
              text: "2248 Broadway #1702\nNew York, NY 10024",
              fontSize: 8,

              border: [false, false, false, false],
            },
            {
              text: "Neta Foundation, Inc.\nEIN 93-2276661",
              fontSize: 8,
              border: [false, false, false, false],
            },
            {
              text: [
                "www.netafoundation.org ",

                {
                  text: "contact@netafoundation.org",
                  link: "mailto:contact@netafoundation.org",
                  color: "blue",
                  decoration: "underline",
                },
              ],
              fontSize: 8,
              border: [false, false, false, false],
            },
          ],
        ],
      },
      margin: [50, 0, 20, 10], // Adjust margins as needed
    };
  },
});

export const compileHtmlToPDF = (template: any) => {
  const docDefinition = buildDocDefinition(template);
  return pdfMake.createPdf(docDefinition).open();
};

export const getCompiledPdfUrl = (template: any) => {
  const docDefinition = buildDocDefinition(template);
  return new Promise<string>((resolve) => {
    pdfMake.createPdf(docDefinition).getBlob((blob: Blob) => {
      resolve(URL.createObjectURL(blob));
    });
  });
};
